export default __webpack_public_path__ + "static/media/Disenoz-Sec-Navy.48322e3d.jpg";